import { Typography, BodyTextProps } from "@packages/ds";
import styled from "styled-components";

import Button from "ds/Button";
import Select from "ds/Select";
import { formAlignmentStyles } from "src/organization/pages/project/ManageBackupSchedulePage/ManageBackupSchedulePage.styles";

export const Error = styled(Typography.BodyText).attrs(
  (props: BodyTextProps) => ({
    size: props.size || "small"
  })
)`
  display: block;
  margin-top: 4px;
  color: var(--mode-text-critical-default);
  grid-column: 1 / 3;
  grid-row: 2 / 3;
`;

export const Row = styled.div`
  ${formAlignmentStyles}
  align-items: baseline;
`;

export const RowLabelWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const BackupIntervalWrapper = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: 80px 1fr;
`;

export const IntervalDurationSelect = styled(Select)`
  width: 136px;
`;

export const BackupsEveryText = styled(Typography.BodyText)`
  margin-left: auto;
`;

export const RemoveRowBtn = styled(Button)`
  margin-left: auto;
`;
